import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Rounded Box Container */}
        <div className="bg-[#0a1929] text-white rounded-3xl p-12">
          {/* Top Section - Logo, Description and Contact Details */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Left Side - Logo and Description */}
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                  <span className="text-[#0a1929] font-bold text-lg">A</span>
                </div>
                <span className="text-2xl font-bold">APTIRIX</span>
              </div>
              <p className="text-gray-400 text-sm max-w-md leading-relaxed mb-4">
                Aptirix is an AI-backed career platform that uses intelligent technology to enhance interviews, 
                build skills, and accelerate career growth.
              </p>
              <p className="text-gray-500 text-xs">©2025 Aptirix.ai</p>
              
              {/* Social Icons */}
              <div className="flex items-center space-x-3 mt-6">
                <a href="https://www.linkedin.com/company/aptirix/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/aptirix_?igsh=MTl0emV4bmJpdjd5bA==" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
                  </svg>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                  </svg>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Right Side - Contact Information */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm">
              <div>
                <h4 className="text-gray-400 font-medium mb-2 text-xs">Visit us</h4>
                <p className="text-gray-300 text-xs leading-relaxed">
                  No 7/14 Gengu Road, Egmore, Chennai 08
                </p>
              </div>
              <div>
                <h4 className="text-gray-400 font-medium mb-2 text-xs">Help & Support</h4>
                <a href="mailto:support@aptirix.com" className="text-gray-300 hover:text-white text-xs transition-colors">
                  contact@aptirix.com
                </a>
              </div>
              <div>
                <h4 className="text-gray-400 font-medium mb-2 text-xs">Job Inquiries</h4>
                <a href="mailto:hr@aptirix.ai" className="text-gray-300 hover:text-white text-xs transition-colors">
                  contact@aptirix.com
                </a>
              </div>
              <div className="sm:col-span-3">
                <h4 className="text-gray-400 font-medium mb-2 text-xs">Product Inquiries</h4>
                <p className="text-gray-300 text-xs">
                  +91 9094770827 (Mon- Fri 10 AM to 7 PM)
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Section - Links Grid */}
          <div className="border-t border-gray-800 pt-8">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
              {/* Company Column */}
              <div>
                <h3 className="text-xs font-semibold uppercase tracking-wider mb-4 text-gray-400">COMPANY</h3>
                <ul className="space-y-2.5">
                  <li><a href="/about" className="text-gray-300 hover:text-white text-sm transition-colors">About Us</a></li>
                  <li><a href="/careers" className="text-gray-300 hover:text-white text-sm transition-colors">Careers</a></li>
                  <li><a href="/demo" className="text-gray-300 hover:text-white text-sm transition-colors">Request Demo Day</a></li>
                  <li><a href="/contact" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix Conversations</a></li>
                </ul>
              </div>

              {/* Industry Column */}
              <div>
                  <h3 className="text-xs font-semibold uppercase tracking-wider mb-4 text-gray-400">INDUSTRIES</h3>
                  <ul className="space-y-2.5">
                  <li><a href="/edtech" className="text-gray-300 hover:text-white text-sm transition-colors">EdTech</a></li>
                  <li><a href="/artificial-intelligence" className="text-gray-300 hover:text-white text-sm transition-colors">Artificial Intelligence</a></li>
                  <li><a href="/career-development" className="text-gray-300 hover:text-white text-sm transition-colors">Career Development</a></li>
                  <li><a href="/hr-tech" className="text-gray-300 hover:text-white text-sm transition-colors">HR Tech</a></li>
                  <li><a href="/skill-development" className="text-gray-300 hover:text-white text-sm transition-colors">Skill Development</a></li>
                  </ul>
                </div>


              {/* Aptirix vs Competitors Column */}
              <div>
                <h3 className="text-xs font-semibold uppercase tracking-wider mb-4 text-gray-400">APTIRIX VS COMPETITORS</h3>
                <ul className="space-y-2.5">
                  <li><a href="/vs-hirevue" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix vs HireVue</a></li>
                  <li><a href="/vs-lever" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix vs Lever</a></li>
                  <li><a href="/vs-greenhouse" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix vs Greenhouse</a></li>
                  <li><a href="/vs-mettl" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix vs Mettl</a></li>
                  <li><a href="/vs-talview" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix vs Talview</a></li>
                  <li><a href="/vs-hackerrank" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix vs HackerRank</a></li>
                  <li><a href="/vs-codility" className="text-gray-300 hover:text-white text-sm transition-colors">Aptirix vs Codility</a></li>
                </ul>
              </div>

              {/* Resources Column */}
              <div>
                <h3 className="text-xs font-semibold uppercase tracking-wider mb-4 text-gray-400">RESOURCES</h3>
                <ul className="space-y-2.5">
                  <li><a href="/blog" className="text-gray-300 hover:text-white text-sm transition-colors">Blog</a></li>
                  <li><a href="/case-studies" className="text-gray-300 hover:text-white text-sm transition-colors">Case Studies</a></li>
                  <li><a href="/support" className="text-gray-300 hover:text-white text-sm transition-colors">Help & Support</a></li>
                  <li><a href="/help-center" className="text-gray-300 hover:text-white text-sm transition-colors">Help Center</a></li>
                  <li><a href="/privacy" className="text-gray-300 hover:text-white text-sm transition-colors">Privacy Policy</a></li>
                  <li><a href="/terms" className="text-gray-300 hover:text-white text-sm transition-colors">Terms of Service</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
